import ScopeService from 'services/ScopeService';
import useSWR, { mutate } from 'swr';
import swrConfig from 'utils/swrConfig';
import { EcomScope } from '../../pb/scopes/v1/ecom_scope_pb';

export const SCOPES_SWR_KEY = 'scopes';

/**
 * Fetches the scopes granted to the current ecom. Usable outside React (thunks, services) -
 * prefer `preloadScopes` so the result also lands in the cache `useScopes` reads.
 */
export async function fetchScopes(): Promise<EcomScope[]> {
    return ScopeService.getScopes();
}

/**
 * Fetches the scopes and seeds the SWR cache with them, so components mounting later read the
 * bootstrapped value instead of firing a second request.
 */
export async function preloadScopes(): Promise<EcomScope[]> {
    const scopes = await fetchScopes();
    await mutate(SCOPES_SWR_KEY, scopes, { revalidate: false });
    return scopes;
}

export const useScopes = () => {
    const { data, error, isLoading, mutate: refetch } = useSWR<EcomScope[]>(SCOPES_SWR_KEY, fetchScopes, swrConfig);

    return { data, error, isLoading, refetch };
};
